import api from "./api";

export const getSupportStats = async () => {
    const res = await api.get("/support/stats");
    return res.data;
};

export const getTickets = async (params = {}) => {
    const res = await api.get("/support/tickets", { params });
    return res.data;
};

export const getTicket = async (ticketId) => {
    const res = await api.get(`/support/tickets/${ticketId}`);
    return res.data;
};

export const createTicket = async (payload) => {
    const res = await api.post("/support/tickets", payload);
    return res.data;
};

export const replyTicket = async (ticketId, payload) => {
    const res = await api.post(`/support/tickets/${ticketId}/reply`, payload);
    return res.data;
};

export const updateTicket = async (ticketId, payload) => {
    const res = await api.patch(`/support/tickets/${ticketId}`, payload);
    return res.data;
};

export const reopenTicket = async (ticketId) => {
    const res = await api.post(`/support/tickets/${ticketId}/reopen`);
    return res.data;
};

export const getTicketActivities = async (ticketId) => {
    const res = await api.get(
        `/support/tickets/${ticketId}/activities`
    );

    return res.data;
};

export const getSupportMetadata = async () => {
    const res = await api.get("/support/metadata");
    return res.data;
};

export const assignTicket = async (ticketId, assignedToAccountId) => {
    const res = await api.post(`/support/tickets/${ticketId}/assign`, {
        assignedToAccountId
    });
    return res.data;
};

export const archiveTicket = async (ticketId) => {
    const res = await api.post(`/support/tickets/${ticketId}/archive`);
    return res.data;
};

export const diagnoseTicket = async (ticketId) => {
    const res = await api.post(`/support/tickets/${ticketId}/diagnose`);
    return res.data;
};

export const getTicketDiagnostics = async (ticketId) => {
    const res = await api.get(`/support/tickets/${ticketId}/diagnostics`);
    return res.data;
};

export const getSupportDashboard = async () => {
    const res = await api.get("/support/dashboard");
    return res.data;
};

export const createDiagnosisNote = async (ticketId) => {
    const res = await api.post(
        `/support/tickets/${ticketId}/diagnosis-note`
    );
    return res.data;
};

export const getSuggestedReply = async (ticketId) => {
    const res = await api.post(
        `/support/tickets/${ticketId}/suggest-reply`
    );
    return res.data;
};

export const executeDiagnosticAction = async (
    ticketId,
    actionKey
) => {
    const res = await api.post(
        `/support/tickets/${ticketId}/diagnostic-action`,
        {
            actionKey
        }
    );

    return res.data;
};

export const getTicketAttachments = async (ticketId) => {
    const res = await api.get(`/support/tickets/${ticketId}/attachments`);
    return res.data;
};

export const uploadTicketAttachment = async (ticketId, file) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await api.post(
        `/support/tickets/${ticketId}/attachments`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );

    return res.data;
};